import React, { Component } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

import Text from './Text';
import Image from './Image';

import { TOUCHABLE, BUTTON_HEIGHT, FORM_WIDTH, GOLDEN200, pOrT } from '../styleConstants';

const sizes = {
  large: {
    width: FORM_WIDTH,
    height: 55,
  },
  middle: {
    width: 100,
    height: BUTTON_HEIGHT,
  },
};

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontSize: pOrT(11, 12),
    color: GOLDEN200,
    zIndex: 9,
    textTransform: 'uppercase',
  },
  disabled: {
    // backgroundColor: 'grey',
  },
  middle: sizes.middle,
  large: sizes.large,
  middleText: {
    marginTop: -2,
  },
  largeText: {
    fontSize: pOrT(13, 15),
  },
});

type Sizes = 'middle' | 'large';

type Props = {
  style?: any;
  hitSlop?: any;
  textStyle?: any;
  children: any;
  onPress: Function;
  disabled?: boolean;
  size?: Sizes;
  testID?: string;
  variant?: 'default' | 'red';
  sizeObj?: any;
};

type State = {
  hovered: boolean;
};

export default class Button extends Component<Props, State> {
  static defaultProps = {
    size: 'middle',
    variant: 'default',
  };
  state = {
    hovered: false,
  };

  onPress = () => {
    const { disabled, onPress } = this.props;

    if (disabled) return;

    onPress();
  };

  render() {
    const { style, disabled, textStyle, size, children, hitSlop, testID, variant } = this.props;

    let { sizeObj } = this.props;

    sizeObj = sizeObj || sizes[size!];

    const { hovered } = this.state;

    return (
      <TouchableOpacity
        onPress={this.onPress}
        {...({
          onMouseEnter: () => {
            this.setState({ hovered: true });
          },
          onMouseLeave: () => {
            this.setState({ hovered: false });
          },
        } as any)}
        style={[styles.base, styles[size!], sizeObj, style, disabled && styles.disabled]}
        hitSlop={
          size !== 'large'
            ? {
                top: TOUCHABLE,
                bottom: TOUCHABLE,
                left: TOUCHABLE,
                right: TOUCHABLE,
                ...hitSlop,
              }
            : hitSlop
        }
        testID={testID}
      >
        {size === 'large' ? (
          <Image
            style={[sizeObj, { position: 'absolute' }]}
            source={
              hovered
                ? variant === 'red'
                  ? require('../../assets/images/longButtonOn2.png')
                  : require('../../assets/images/longButtonOn.png')
                : variant === 'red'
                ? require('../../assets/images/longButton2.png')
                : require('../../assets/images/longButton.png')
            }
          />
        ) : null}
        {size === 'middle' ? (
          <Image
            style={[sizeObj, { position: 'absolute' }]}
            resizeMode="stretch"
            source={
              disabled
                ? require('../../assets/images/buttonDisabled.png')
                : variant === 'red'
                ? require('../../assets/images/button2.png')
                : require('../../assets/images/button.png')
            }
          />
        ) : null}
        <Text bold style={[styles.text, (styles as any)[`${size}Text`], textStyle]}>
          {children}
        </Text>
      </TouchableOpacity>
    );
  }
}
